import HighchartsReact from "highcharts-react-official";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "reactstrap";
import Highcharts, { color } from "highcharts";
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Icon } from "@progress/kendo-react-common";
import moment from "moment";
import { makeStyles } from "@material-ui/core";
import { getMonthDateRange, getUserId, getUserRole } from "../../../_helper/helper";
import { Person } from "@mui/icons-material";
import { bg } from "date-fns/locale";
import { post } from "../../../_helper/api_helper";
import { useAuth } from "oidc-react";

const bgColor = {
  "Past Due": {
    color: "#F44336",
    bg: "#FFCDD2",
    icon: <Person style={{ color: "#F44336" }} />,
  },
  "No Activity": {
    color: "#f57c00",
    bg: "#ffe0b2",
    icon: <Person style={{ color: "#f57c00" }} />,
  },

  "In-Progress-Sup": {
    color: "#2196f3", // OrangeRed - High Importance
    bg: "#BBDEFB", // Moccasin
    icon: <Person style={{ color: "#2196f3" }} />,
  },

  "In-Progress-Prep": {
    color: "#f6685e", // RoyalBlue - High Importance
    bg: "#F8BBD0", // LightSteelBlue
    icon: <Person style={{ color: "#f6685e" }} />,
  },

  "In-Progress-Emp": {
    color: "#3f51b5", // GoldenRod - Medium Importance
    bg: "#C5CAE9", // Cornsilk
    icon: <Person style={{ color: "#3f51b5" }} />,
  },

  "In-Progress-Rev": {
    color: "#00bcd4", // ForestGreen - Medium Importance
    bg: "#B2EBF2", // Honeydew
    icon: <Person style={{ color: "#00bcd4" }} />,
  },

  "In-Progress-Dir": {
    color: "#8bc34a", // Gray - Lower Importance
    bg: "#DCEDC8", // Very Light Gray
    icon: <Person style={{ color: "#8bc34a" }} />,
  },

  "Completed-NPA Mode": {
    color: "#388e3c", // DarkGreen
    bg: "#C8E6C9", // LightGreen
    icon: <Person style={{ color: "#388e3c" }} />,
  },
};

const PEChartMain = () => {
  const [benefitsData, setBenefitsData] = useState([]);
  const [columnChartData, setColumnChartData] = useState([]);
  const [columnChartY, setColumnChartY] = useState([]);
  const [days, setDays] = useState("Last");
  const [chart, setChart] = useState("column");
  const [dateRanges, setDateRanges] = useState({ startDate: "", endDate: "" });
  const [pieData, setPieData] = useState({
    seriesData: [],
    drilldownSeries: [],
  });

    const { userData } = useAuth();
    const userRole = getUserRole(userData)
    const userId = getUserId(userData)

  console.log("Dasdadadasd", pieData);
  const formatData = (data) => {
    const groupedData = data.reduce((acc, item) => {
      const date = item.ndate_Increm.split("T")[0];
      if (!acc[date]) {
        acc[date] = {};
      }
      const status = item.CurrentProcessStatus;
      if (!acc[date][status]) {
        acc[date][status] = 0;
      }
      acc[date][status] += item.total;
      return acc;
    }, {});

    return Object.entries(groupedData).map(([date, statuses]) => {
      return { ...statuses, date: moment(date).format("YYYY-MM-DD") };
    });
  };
  const customOrder = [
    "Past Due",
    "No Activity",
    "In-Progress-Prep",
    "In-Progress-Emp",
    "In-Progress-Sup",
    "In-Progress-Rev",
    "In-Progress-Dir",
    "Completed-NPA Mode",
  ];

  const sortDataByStatus = (data) => {
    const orderMap = customOrder.reduce((acc, name, index) => {
      acc[name] = index;
      return acc;
    }, {});

    return data.sort((a, b) => {
      return orderMap[a.name] - orderMap[b.name];
    });
  };

  const transformData = (data) => {
    const statuses = new Set();

    // Collect all unique statuses
    data.forEach((item) => {
      Object.keys(item).forEach((key) => {
        if (key !== "date") {
          statuses.add(key);
        }
      });
    });

    // Initialize the result array
    const result = Array.from(statuses).map((status) => ({
      name: status,
      data: [],
      color: bgColor[status].color,
    }));
    const sortData = sortDataByStatus(result);
    console.log("dasdadadasda", sortData);
    // Populate the data for each status
    data.forEach((item) => {
      sortData.forEach((statusObj) => {
        statusObj.data.push(item[statusObj.name] || 0);
      });
    });

    return result;
  };
  
  const getBenefitsData = async (startDate, endDate) => {
    // const newBaseURL = process.env.REACT_APP_WEB_API_URL
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    
    const payload = {
      tableName: "fn_pe_statistics",
      searchParams: JSON.stringify([
        {
          columnName: "UserID",
          value: userId,
          operator: "=",
          dataType: "BIGINT",
        },
        {
          columnName: "userrole",
          value: userRole,
          operator: "=",
          dataType: "VARCHAR(50)",
        },
      ]),
      columns: "*",
      pageNumber: 1,
      pageSize: 10000,
      sortData: "",
      additionalWhere: `Ndate_Increm >= '${startDate}' and Ndate_Increm <= '${endDate}'`,
      location: "global",
    };

    try {
      const response = await advanceSearch(payload);
      const { results, rowCount } = response;
      let groupedData = formatData(results);

      let trData = transformData(Object.values(groupedData));
      console.log("Dasdsdadada", trData);
      setColumnChartY(Object.values(groupedData));
      setColumnChartData(trData);

      setBenefitsData(results);
      // setRowCount(rowCount);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setLoading(false);
    }
  };

  const pieRender = (data) => {
    let sortData = sortDataByStatus(data);
    console.log("asdadasdda", sortData);

    const groupedData = data.reduce((acc, item) => {
      const status = item.CurrentProcessStatus;
      if (!acc[status]) {
        acc[status] = 0;
      }
      acc[status] += 1;
      return acc;
    }, {});

    return Object.entries(groupedData)?.map(([status, count]) => {
      return {
        name: status,
        y: count,
        color: bgColor[status]?.color,
      };
    });
  };

  useEffect(() => {
    console.log("Dadasdadasda", days);
    if (days == "Last") {
      let startDate = moment().subtract(7, "days").format("YYYY-MM-DD");
      let endDate = moment().format("YYYY-MM-DD");
      setDateRanges({ startDate, endDate });
      getBenefitsData(startDate, endDate);
      getPieChartData(startDate, endDate);
    } else if (days == "Next") {
      let startDate = moment().add(1, "days").format("YYYY-MM-DD");
      let endDate = moment().add(7, "days").format("YYYY-MM-DD");
      setDateRanges({ startDate, endDate });
      getBenefitsData(startDate, endDate);
      getPieChartData(startDate, endDate);
    } else if (days == "LastMonth") {
      let { startDate, endDate } = getMonthDateRange("LastMonth");
      setDateRanges({ startDate, endDate });
      getBenefitsData(startDate, endDate);
      getPieChartData(startDate, endDate);
    } else if (days == "ThisMonth") {
      let { startDate, endDate } = getMonthDateRange("ThisMonth");
      setDateRanges({ startDate, endDate });
      getBenefitsData(startDate, endDate);
      getPieChartData(startDate, endDate);
    } else if (days == "NextMonth") {
      let { startDate, endDate } = getMonthDateRange("NextMonth");
      setDateRanges({ startDate, endDate });
      getBenefitsData(startDate, endDate);
      getPieChartData(startDate, endDate);
    }
  }, [days]);

  
  const status = {
    "Past Due": "Past Due",
    "PE Not Initiated": "No Activity",
    "PE Prep": "In-Progress-Prep",
    "Employee Review": "In-Progress-Emp",
    "Supervisor Review": "In-Progress-Sup",
    "Reviewer Review": "In-Progress-Rev",
    "Agency Director Review": "In-Progress-Dir",
    "NPA Required": "Completed-NPA Mode",
    "Payroll Posted": "Completed-NPA Mode",
    "Payroll Staging": "Completed-NPA Mode",
  };

  const getPieChartData = async (startDate, endDate) => {
    try {
      const getPieData = await post(
        `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global`,
        {
          additionalWhere: `FORMAT(Ndate_Increm , 'yyyy-MM-dd') >= '${moment(
            startDate,
            "YYYY-MM-DD"
          ).format(
            "YYYY-MM-DD"
          )}' and FORMAT(Ndate_Increm , 'yyyy-MM-dd') <= '${moment(
            endDate,
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD")}'`,
          tableName: "fn_PerformanceEvaluation",
          searchParams: JSON.stringify([
            {
              columnName: "UserID",
              value: userId,
              operator: "=",
              dataType: "BIGINT",
            },
            {
              columnName: "userrole",
              value: userRole,
              operator: "=",
              dataType: "VARCHAR(50)",
            },
          ]),
          // searchParams: JSON.stringify([]),
          columns:
            "HrControl ,EmployeeName ,Ndate_Increm ,ID,ApprovalStatus ,days_remaining ,EmployeeID,pe_status",
          pageNumber: 1,
          pageSize: 1000000,
          sortData: "",
          qID: 0,
          location: "global",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        }
      );
      console.log("asdadadadadadadada 1", getPieData);

      if (getPieData?.results) {
        const groupedData = getPieData?.results.reduce((acc, curr) => {
          let statusFormat = status?.[curr?.ApprovalStatus] ||
          (curr?.Ndate_Increm >= moment().format("YYYY-MM-DD")
            ? status?.["PE Not Initiated"]
            : status?.["Past Due"])
          if (acc[statusFormat]) {
            acc[statusFormat].push(curr);
          } else {
            acc[statusFormat] = [curr];
          }
          return acc;
        }, {});

        // Prepare series data
        const seriesData = Object.keys(groupedData).map((status) => ({
          name: status,
          y: groupedData[status].length,
          drilldown: status,
          color:bgColor[status].color
        }));

        // Prepare drilldown data
        const drilldownSeries = Object.keys(groupedData).map((status) => ({
          name: status,
          id: status,
          data: groupedData[status].map((item) => [
            item.EmployeeName,
            item.EmployeeID,
          ]),
        }));

        setPieData({ seriesData, drilldownSeries });
        console.log("asdadadadadadadada", seriesData, drilldownSeries);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const getChartDetails = (chart, type) => {
    if (type === "pie") {
      let series_name = "";
      let series_data = [];
      let empshare = [];
      let chart_title = "PE Statistics";

      let opPie = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: "pie",
        },
        title: {
          text: chart_title,
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}:{point.y}</b>",
            },
          },
        },
        series: [
          {
            name: "PE",
            colorByPoint: true,
            data: pieData?.seriesData, // pieRender(benefitsData)
          },
        ],

        drilldown: {
          series: pieData?.drilldownSeries,
        },
      };
      return opPie;
    }
    if (type === "column" || type === "spline") {
      let series_name = "";
      let series_data = [];
      let empshare = [];
      let chart_title = "PE Statistics";

      let opPie = {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: type,
        },
        title: {
          text: chart_title,
        },
        xAxis: {
          categories: columnChartY.map((i) =>
            i.date ? moment(i.date).format("DD/MM/YYYY") : i.date
          ),
          crosshair: true,
          accessibility: {
            description: "PE Status",
          },
          labels: {
            formatter: function () {
              // Customize your labels here
              return this.value;
            },
          },
          title: {
            text: `Performance Eval Activity ${
              dateRanges?.startDate
                ? moment(dateRanges?.startDate).format("MM/DD/YYYY")
                : null
            } to ${
              dateRanges?.endDate
                ? moment(dateRanges?.endDate).format("MM/DD/YYYY")
                : null
            }`,
          },
        },
        yAxis: {
          crosshair: true,
          accessibility: {
            description: "PE Status",
          },
          title: {
            text: "PE Work",
          },
        },
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y}</b>",
        },
        accessibility: {
          point: {
            valueSuffix: "%",
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}:{point.y}</b>",
            },
          },
        },
        series: columnChartData,
      };
      return opPie;
    }
  };

  return (
    <div>
      <Row className="bg-primary rounded py-3 mb-3">
        <Col md={6} style={{ alignSelf: "center" }}>
          <Typography variant="h5">
            <Icon style={{ fontSize: "25px" }} name="graph" />
            PE Analysis
          </Typography>
        </Col>
        <Col md="6" style={{ display: "flex", justifyContent: "end" }}>
          <FormControl sx={{ m: 1, minWidth: 220 }} size="small">
            <InputLabel id="demo-select-small-label" style={{ color: "white" }}>
              Select Chart
            </InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={chart}
              sx={{ borderColor: "white" }}
              label="Age"
              style={{ color: "white" }}
              onChange={(e) => {
                setChart(e.target.value);
              }}
            >
              <MenuItem value={"column"}>Column Chart</MenuItem>
              <MenuItem value={"spline"}>Spline Chart</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 220 }} size="small">
            <InputLabel id="demo-select-small-label" style={{ color: "white" }}>
              Select Days
            </InputLabel>
            <Select
              labelId="demo-select-small-label"
              id="demo-select-small"
              value={days}
              sx={{ borderColor: "white" }}
              label="Age"
              style={{ color: "white" }}
              onChange={(e) => {
                console.log("Daddadada", e.target.value);
                setDays(e.target.value);
              }}
            >
              <MenuItem value={"Last"}>Last 7 days</MenuItem>
              <MenuItem value={"Next"}>Next 7 days</MenuItem>
              <MenuItem value={"LastMonth"}>Last Month</MenuItem>
              <MenuItem value={"ThisMonth"}>This Month</MenuItem>
              <MenuItem value={"NextMonth"}>Next Month</MenuItem>
            </Select>
          </FormControl>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card className="p-3">
            <HighchartsReact
              highcharts={Highcharts}
              options={getChartDetails("column", chart)}
            />
          </Card>
        </Col>
        <Col md={12}>
          <Card className="p-3">
            <HighchartsReact
              highcharts={Highcharts}
              options={getChartDetails("column", "pie")}
            />
          </Card>
        </Col>
      </Row>
      <Row></Row>
    </div>
  );
};

export default PEChartMain;
